// @mui
import { styled, alpha } from "@mui/material/styles";
// utils
import { bgGradient } from "../../utils/cssStyles";
import bg from ".././../assets/illustrations/AuthBackground.png";

// ----------------------------------------------------------------------

export const StyledRoot = styled("main")(() => ({
  height: "100vh",
  display: "flex",
  position: "relative",
  backgroundImage: `url(${bg})`,
  overflow: "scroll",
}));

export const StyledSection = styled("div")(({ theme }) => ({
  display: "none",
  position: "relative",
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    display: "flex",
    flexBasis: "50%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
}));

export const StyledSectionBg = styled("div")(({ theme }) => ({
  ...bgGradient({
    color: alpha(
      theme.palette.background.default,
      theme.palette.mode === "light" ? 0.9 : 0.94
    ),
    imgUrl: "/assets/background/overlay_2.jpg",
  }),
  top: 0,
  left: 0,
  zIndex: -1,
  width: "100%",
  height: "100%",
  position: "absolute",
  transform: "scaleX(-1)",
}));

export const StyledContent = styled("div")(({ theme }) => ({
  width: "100%",
  margin: "auto",
  display: "flex",
  minHeight: "90vh",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(10, 2),
  [theme.breakpoints.up("md")]: {
    width: "70%",
    flexShrink: 0,
    // padding: theme.spacing(30, 8, 0, 8),
  },
}));
